import Hint from '../components/Hint'
import Screenshot, { ScreenshotRef } from '../components/Screenshot'
import { Page } from './types'

const render = () => <div className="row">
    <div className="col-8">
        <ul>
            <li>Login on the Gurobi website <ScreenshotRef label="1"/></li>
            <li>At the top, click <i>Downloads &amp; Licenses</i> and then <i>Your Gurobi Licenses</i> <ScreenshotRef label="2"/></li>
            <li>Scroll to the license you want to use</li>
            <li>On the ride side in this table row, click <i>Install</i> ; you should see a popup <ScreenshotRef label="3"/></li>
            <li>Copy the <code>grbgetkey</code> command listed, together with the code <ScreenshotRef label="4"/></li>
            <li>Open a command prompt and execute this command on the machine where you installed Gurobi or the license tools</li>
        </ul>
        
        <Hint title='No internet connection?'>
            You may also run the <code>grbprobe</code> tool on the machine where Gurobi was installed. It will provide you with
            the information you need to manually activate your license through our website on a different machine that does have
            an internet connection. Contact us for more information.</Hint>
    </div>
    <aside className="screenshots col-4">
        <Screenshot label="1" src="01-login.png"/>
        <Screenshot label="2" src="02-find-licenses.png"/>
        <Screenshot label="3" src="03-install-regular.png"/>
        <Screenshot label="4" src="04-grbgetkey.png"/>
    </aside>
</div>

const descriptor : Page<{}> = { key: 'retrieve-local-license', title: 'Retrieving a license', render }

export default descriptor